export const modalFactory = [ '$templateRequest', '$sce', '$compile', function( $templateRequest, $sce, $compile ) {

    var modalFactory = {
        open: false,
        modal: undefined
    };

    modalFactory.create = function($scope, parent, templateUrl, callback){
        angular.element(document.documentElement).addClass('u-ScrollLock');
        $templateRequest(templateUrl).then(function(html) {

            modalFactory.modal = angular.element(html);
            parent.append(modalFactory.modal);
            $compile(modalFactory.modal)($scope);

            // TweenMax.fromTo(
            //     modalFactory.modal,
            //     0.5,
            //     {opacity: 0 },
            //     {opacity: 1, ease:Power1.easeInOut }
            // );

            if(typeof callback !== 'undefined'){
                modalFactory.callback = callback;
            }

        }, function() {
            // An error has occurred
        });
    };

    modalFactory.close = function(){
        angular.element(document.documentElement).removeClass('u-ScrollLock');

        // TweenMax.fromTo(
        //     modalFactory.modal,
        //     0.5,
        //     {opacity: 1 },
        //     {opacity: 0, ease:Power1.easeInOut, onComplete: removeModal }
        // );
        function removeModal(){
            modalFactory.modal.remove();
        }
        removeModal();
    };

    return modalFactory;
}]

export const closeModal = ['modalFactory', function($modal){
    return {
        link: function($scope, $element){
            $element.on('click', function(){
                $modal.close();
            });
        }
    };
}]

export const modalCallback = ['modalFactory', function($modal){
    return {
        link: function($scope, $element){
            $element.on('click', function(){
                if(typeof callback !== 'undefined'){
                    $modal.callback();
                }
                $modal.close();
            });
        }
    };
}];